import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';
import { crudResult } from '../../dataContracts';

export const updateDealership = async (data) => {
  const { dealershipId, operatingUnitId, areaCode, phoneNumber, ...updates } = data || {};
  if (!dealershipId) {
    console.error('ID de concesionario no proporcionado');
    return { success: 'no', message: 'ID de concesionario no proporcionado' };
  }

  try {
    const updateDealershipFn = httpsCallable(functions, 'updateDealershipV2');
    const payload = {
      dealershipId,
      operatingUnitId,
      requestedApp: 'dealership_web',
      ...updates,
    };
    const result = await updateDealershipFn(payload);
    return crudResult(result.data);
  } catch (error) {
    console.error('Error al actualizar concesionario:', error);
    notifyPermissionDenied(error);
    if (/permission-denied|unauthenticated/.test(error.code || '')) throw error;
    return { success: 'no', message: error.message, code: error.code || null };
  }
};
